import React, {Fragment, useEffect, useState} from 'react';
import {Button, Nav, Navbar, Row, Col} from 'reactstrap';
import {connect} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {setToken, setMostrarOcultarMenu} from '../reducer/user-reducer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
  faBook,
  faFile,
  faRightFromBracket,
  faBars,
  faLink,
  faBell,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import '../sass/menu.scss';
import ItemMenu from './itemMenu';

interface MenuProps {
  token: string;
  setToken(token: string): null;
  menuDesplegado: boolean;
  setMostrarOcultarMenu(prop: boolean): null;
  logo: string;
}
interface configObject {
  user: {
    token: string;
    menuDesplegado: boolean;
  };
  configReducer: {
    siteConfig: {
      styles: {
        logo: string;
      };
    };
  };
}

const Menu: React.FC<MenuProps> = (props: MenuProps) => {
  const [finallyHide, setFinallyHide] = useState(false);
  const {setToken, menuDesplegado, setMostrarOcultarMenu, logo} = props;
  const navigate = useNavigate();
  const salir = () => {
    navigate('/admin/login');
    navigate(0);
    setToken('');
    localStorage.removeItem('token');
  };
  const mostrarOcultarMenu = () => {
    let propiedad = !menuDesplegado;
    setMostrarOcultarMenu(propiedad);
  };

  useEffect(() => {
    if (menuDesplegado) {
      setFinallyHide(true);
    } else {
      setFinallyHide(false);
    }
  }, [menuDesplegado]);

  const menuNavegacion = [
    {
      label: 'list_articles',
      linkTo: '/admin/listar-articulos',
      icon: faBook,
      event: mostrarOcultarMenu,
    },
    {
      label: 'new_article',
      linkTo: '/admin/nuevo-articulo',
      icon: faFile,
      event: mostrarOcultarMenu,
    },
    {
      label: 'create_register_link',
      linkTo: '/admin/nuevo-link-registro',
      icon: faLink,
      event: mostrarOcultarMenu,
    },
    {
      label: 'send_notifications',
      linkTo: '/admin/enviar-notificaciones',
      icon: faBell,
      event: mostrarOcultarMenu,
    },
    {
      label: 'Usuarios',
      linkTo: '/admin/usuarios',
      icon: faUser,
      event: mostrarOcultarMenu,
    },
    {
      label: 'go_out',
      linkTo: null,
      icon: faRightFromBracket,
      event: salir,
    },
  ];
  return (
    <Fragment>
      <Button
        onClick={mostrarOcultarMenu}
        className="background-primary border-primary mt-3 button-menu"
      >
        <FontAwesomeIcon icon={faBars} size="lg" />
      </Button>
      <Navbar
        expand="md"
        className={
          'right-menu position-fixed top-0 background-secondary d-block'
        }
        style={{
          animationName: menuDesplegado ? 'run' : 'back',
          right: finallyHide ? '0' : '-400px',
        }}
      >
        <div className="d-flex flex-column">
          {logo && (
            <Row>
              <Col md={{size: 6}} xs={8}>
                <img src={logo} alt="" className="img-fluid mt-3" />
              </Col>
              <Col md={6} xs={4} className="text-end">
                <Button
                  className="mt-2 background-secondary border-0 color-primary"
                  onClick={mostrarOcultarMenu}
                >
                  <FontAwesomeIcon icon={faBars} />
                </Button>
              </Col>
            </Row>
          )}
          <Nav className="ms-auto mt-4">
            {menuNavegacion.map((menuItem, index) => {
              return (
                <ItemMenu
                  key={index}
                  label={menuItem.label}
                  linkTo={menuItem.linkTo}
                  icon={menuItem.icon}
                  event={menuItem.event}
                />
              );
            })}
          </Nav>
        </div>
      </Navbar>
    </Fragment>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    token: state.user.token,
    menuDesplegado: state.user.menuDesplegado,
    logo: state.configReducer.siteConfig.styles.logo,
  };
};
export default connect(mapStateToProps, {setToken, setMostrarOcultarMenu})(
  Menu,
);
